import React, { useState } from 'react'
import { format } from 'date-fns'

import { PostListStyled, PostListItemStyled, PostListContainerStyled, PostListPaginationStyled } from './styles'
import PostBox from './../../molecules/PostBox'
import { PostListProps } from './types'
import Pagination from './../../molecules/Pagination'
import generatePath from '../../../utils/generatePath'
import { Routes } from '../../../setup/consts'
import usePageContext from '../../../hooks/usePageContext'
import { scrollToSection } from './../../../common/helpers'

const PostList: React.FC<PostListProps> = ({ data, isSubCategory, isColumn, withPagination, cols, postsPerPage = 6 }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const { lang } = usePageContext()

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = data?.slice(indexOfFirstPost, indexOfLastPost) || []

  // Change page
  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber)
    scrollToSection(`post-list-container`, 600, 0, -220)
  }

  return (
    <PostListContainerStyled name="post-list-container">
      <PostListStyled {...{ isColumn }}>
        {currentPosts.map((post) => {
          const { id, url, slug, date, title = '', excerpt, featuredImage, categories } = post || {}

          return (
            <PostListItemStyled key={id} {...{ cols }}>
              <PostBox
                isShortened={isSubCategory}
                url={
                  url ||
                  generatePath(Routes.Blog, {
                    category: categories?.nodes[0]?.slug,
                    post: categories?.nodes[0]?.slug ? slug : undefined,
                    lang
                  })
                }
                {...{ title }}
                date={date ? format(new Date(date.substring(0, 10)), 'dd.MM.yyyy') : ''}
                content={excerpt}
                category={categories?.nodes[0].name}
                image={featuredImage?.node?.sourceUrl}
                alt={featuredImage?.node?.altText}
              />
            </PostListItemStyled>
          )
        })}
      </PostListStyled>
      {withPagination && postsPerPage < data.length ? (
        <PostListPaginationStyled>
          <Pagination currentPage={currentPage} postsPerPage={postsPerPage} totalPosts={data.length} paginate={paginate} />
        </PostListPaginationStyled>
      ) : (
        ''
      )}
    </PostListContainerStyled>
  )
}

export default PostList
